<template>
  <b-container v-if="selected.length > 0" class="p-0 mt-2">
    <div class="whitecard indice-detail halfHeight" :class="{ 'fullHeight':layout }">
      <b-row no-gutters>
        <b-col class="p-0">
          <h3>Edit {{ indice.name }}</h3>
        </b-col>
        <b-col class="p-0 text-right" cols="2">
          <b-btn variant="outline-secondary" size="sm" @click="closeIndice">
            <i class="fa fa-times" /> Close
          </b-btn>
        </b-col>
      </b-row>
      <b-row class="indices-select mt-2" no-gutters>
        <b-col cols="12" class="px-2">
          <div class="options-panel">
            <div
              v-for="i in selected"
              :key="i.value"
              class="selected"
              @click="removeSelection(i)"
            >
              {{ i.name }}
            </div>
          </div>
        </b-col>
        <b-col class="px-2">
          <b-input-group>
            <b-form-input
              v-model="search"
              :placeholder="`Search ${indice ? indice.name : ''}`"
              @keyup="debounceSearch"
            >
            </b-form-input>
            <b-input-group-append>
              <b-btn variant="secondary" size="sm" @click="clearSearch">
                <i class="fa fa-times" />
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" class="px-2">
          <div class="options-panel halfHeight" :class="{ 'fullHeight':layout }">
            <div
              v-for="i in options"
              :key="i.value"
              class="selected options"
              :class="{ active: checkSelection(i) }"
              @click="addToSelection(i)"
            >
              {{ i.name }}
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import _ from "lodash";
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/eventBus";

export default {
  name: "IndicesDetail",
  components: {},
  props: {
    indice: {
      type: Object,
      required: false,
      default: null,
    },
    layout: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      search: null,
      options: [],
      selected: [],
    };
  },
  computed: {
    ...mapState({
      documentsPerYear: (state) => state.document.documentsPerYear,
    }),
  },
  watch: {},
  mounted() {
    EventBus.$on("indiceDetail", (indice) => {
      this.getIndices(indice);
    });
  },
  methods: {
    ...mapActions(["searchIndices", "searchFields"]),
    clearSearch() {
      this.search = null;
      this.options = [];
    },
    closeIndice() {
      this.options = [];
      this.selected = [];
      this.search = null;
      EventBus.$emit("closeIndice", "close");
    },
    removeSelection(item) {
      this.selected.splice(
        _.findIndex(this.selected, function (o) {
          return o.value === item.value;
        }),
        1
      );
      EventBus.$emit("editIndice", this.selected);
      if (this.selected.length < 1) {
        this.closeIndice();
      }
    },
    addToSelection(item) {
      if (!this.checkSelection(item)) {
        this.selected.push(item);
        EventBus.$emit("editIndice", this.selected);
      } else {
        this.removeSelection(item);
      }
    },
    checkSelection(item) {
      if (
        _.find(this.selected, function (o) {
          return o.value === item.value;
        })
      ) {
        return true;
      } else {
        return false;
      }
    },
    getIndices(indice) {
      if (_.isArray(indice.info)) {
        let index = 0;
        _.each(indice.info, (ind) => {
          this.selected.push({
            name: ind,
          });
        });
        _.each(indice.value, (val) => {
          let name = this.selected[index].name;
          this.selected.splice(index, 1, {
            name: name,
            value: val,
          });
          index += 1;
        });
      } else {
        this.selected.push({
          name: indice.info,
          value: indice.value,
        });
      }
    },
    debounceSearch: _.debounce(function () {
      if (!this.search || this.search === "") {
        this.options = [];
        return false;
      }
      if (this.indice.type === "field") {
        this.searchFields({
          query: this.search,
          index: this.indice.name,
        }).then((res) => {
          this.options = res.map((item) => {
            return {
              name: item.name,
              value: item._id,
            };
          });
        });
      } else if (this.indice.type === "year") {
        let years = _.filter(this.documentsPerYear, (y) => {
          return y.year.includes(this.search) && y.amount > 0;
        });
        this.options = years.map((item) => {
          return {
            name: item.year,
            value: item._id,
          };
        });
      } else {
        this.searchIndices({
          query: this.search,
          index: this.indice.name,
        }).then((res) => {
          this.options = res.map((item) => {
            return {
              name: item.name,
              value: item._id,
            };
          });
        });
      }
    }, 400),
  },
};
</script>
